import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import { Button } from "@mui/material";
import TabList from '@mui/lab/TabList';
import Roles from "../components/Roles";
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import { addNewRole, loadRoleList } from "../api/roleapi";
import AddIcon from '@mui/icons-material/Add';
import LoaderComponent from "../components/LoaderComponent";
import { getRoleList,  getRoleLoading,getRoleDialogStatus } from "../selector/selectors";
import RoleModal from "../components/RoleModal";
import { closeRoleDialog, openRoleDialog } from "../state/role/actions";
import { Link } from "react-router-dom";

function ManageRoles({
  isLoading,
  roleList,
  addNewRole,
  startLoadingRoles,
  roleDialogBoxStatus,
}) {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [roleData, setRoleData] = useState({
        name : '',
        role_type : '',
        description:''
    });
    // const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);

    useEffect(() => {
      startLoadingRoles();
    }, [startLoadingRoles]);

    useEffect(() => {
        if(roleDialogBoxStatus === false) {
            setRoleData({
                name : '',
                description:''
            });
        }
    }, [roleDialogBoxStatus]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClickOpenRole = () => {
        document.activeElement.blur(); 
        dispatch(openRoleDialog());
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingRoles(pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingRoles(0,event.target.value);
    }

    const handleFormData = () => {
        if(roleData.length === 0 || roleData.name === '' || roleData.role_type === '' || roleData.description === ''){
          swal("Oops!", "Please fill required fields!", "error");
          return false;
        }
        addNewRole(roleData);
        if(roleDialogBoxStatus === false) {
            dispatch(closeRoleDialog());
        }
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Roles" value="1" />
                                <Link className="tabingLinks" to="/web/users">Users</Link>
                                {/* <Link className="tabingLinks" to="/web/app/users">Manage SiteTech app users</Link> */}
                                <Link className="tabingLinks" to="/web/permissions">Access Control</Link>
                                {/* {list?.data?.userDetails?.role_id === 1 &&
                                    <Link className="tabingLinks" to="/web/controller-permissions">Controller Access Control</Link>
                                } */}
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'flex-end'}}>
                                <Button 
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    onClick={handleClickOpenRole}
                                >
                                    <AddIcon fontSize="medium"  sx={{paddingRight:1}} /> Add
                                </Button> 
                            </Grid>
                            <Roles roles={roleList} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
                <RoleModal
                    open={roleDialogBoxStatus || false}
                    value={roleData}
                    setRoleData={setRoleData}
                    handleFormData={handleFormData}
                />
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading: getRoleLoading(state),  
  roleList:getRoleList(state),  
  roleDialogBoxStatus: getRoleDialogStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    addNewRole: (data)  => dispatch(addNewRole(data)),
    startLoadingRoles: (page,rowsPerPage) => dispatch(loadRoleList(page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageRoles);

